import React from 'react'
import { Dialog, DialogContent, DialogTitle } from '../ui/dialog'

export const MOBILE_BOTTOM_SHEET_CONTENT_CLASS =
  'left-0 right-0 top-auto bottom-0 max-w-none translate-x-0 translate-y-0 rounded-b-none rounded-t-[28px] border-0 border-t border-[rgba(36,34,30,0.06)] bg-white px-6 pb-[calc(env(safe-area-inset-bottom)+2.5rem)] pt-5 shadow-[0_-24px_60px_rgba(61,59,54,0.10)]'

export const MOBILE_BOTTOM_SHEET_OVERLAY_CLASS = 'bg-transparent'

export const MOBILE_BOTTOM_SHEET_ROW_CLASS =
  'flex w-full items-center justify-between py-4 text-left font-sans text-fs-300 text-ink-700 transition-colors duration-settle ease-precise active:opacity-70 focus-visible:outline-none'

export const MOBILE_BOTTOM_SHEET_DESTRUCTIVE_ROW_CLASS =
  'flex w-full items-center justify-between py-4 text-left font-sans text-fs-300 text-[#83352A] transition-colors duration-settle ease-precise active:bg-[rgba(131,53,42,0.04)] active:opacity-100 focus-visible:outline-none'

export interface MobileBottomSheetProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  children: React.ReactNode
  contentClassName?: string
  overlayClassName?: string
}

export const MobileBottomSheet: React.FC<MobileBottomSheetProps> = ({
  open,
  onOpenChange,
  title,
  children,
  contentClassName,
  overlayClassName,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        showCloseButton={false}
        animationVariant="settle"
        className={
          contentClassName
            ? `${MOBILE_BOTTOM_SHEET_CONTENT_CLASS} ${contentClassName}`
            : MOBILE_BOTTOM_SHEET_CONTENT_CLASS
        }
        overlayClassName={overlayClassName ?? MOBILE_BOTTOM_SHEET_OVERLAY_CLASS}
        aria-describedby={undefined}
      >
        <DialogTitle className="sr-only">{title}</DialogTitle>
        {children}
      </DialogContent>
    </Dialog>
  )
}

export default MobileBottomSheet
